<template>
  <teleport to="body">
    <div
      v-if="show"
      class="confirm-delete-backdrop"
      @click.self="cancel"
    >
      <div class="confirm-delete-modal card border-0 shadow-lg">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0 fw-bold text-danger">{{ title }}</h5>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="cancel"
            :disabled="loading"
          >
            ✕
          </button>
        </div>

        <div class="card-body">
          <p class="mb-0 confirm-delete-message">{{ message }}</p>

          <p class="text-danger small mt-3 mb-0">
            This action cannot be undone.
          </p>
        </div>

        <div class="card-footer d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="cancel"
            :disabled="loading"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-danger"
            @click="confirm"
            :disabled="loading"
          >
            {{ loading ? 'Deleting...' : confirmText }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
// Usage:
//   <ConfirmDeleteModal ref="confirmDelete" />
//   this.$refs.confirmDelete.open({
//     title: 'Delete Driver',
//     message: 'Are you sure you want to delete "John"?',
//     onConfirm: () => this.deleteDriver(id)
//   })
export default {
  name: 'ConfirmDeleteModal',

  data() {
    return {
      show: false,
      loading: false,
      title: '',
      message: '',
      confirmText: 'Delete',
      onConfirm: null
    }
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown)
  },

  methods: {
    open({ title, message, confirmText, onConfirm }) {
      this.title = title || 'Confirm Delete'
      this.message = message || 'Are you sure you want to delete this item?'
      this.confirmText = confirmText || 'Delete'
      this.onConfirm = onConfirm
      this.loading = false
      this.show = true
      window.addEventListener('keydown', this.onKeydown)
    },

    close() {
      this.show = false
      this.loading = false
      this.onConfirm = null
      window.removeEventListener('keydown', this.onKeydown)
    },

    cancel() {
      if (this.loading) return
      this.close()
    },

    async confirm() {
      if (this.loading || !this.onConfirm) return

      this.loading = true
      try {
        await this.onConfirm()
      } finally {
        this.close()
      }
    },

    onKeydown(e) {
      if (e.key === 'Escape') this.cancel()
    }
  }
}
</script>

<style scoped>
.confirm-delete-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 99991;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm-delete-modal {
  width: 100%;
  max-width: 480px;
  border-radius: 18px;
  overflow: hidden;
}

.confirm-delete-message {
  white-space: pre-line;
  word-break: break-word;
}
</style>
